import { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useDocumentTitle from "../../utils/useDocumentTitle";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import { DashboardLayout } from "../../layouts/DashboardLayout";
import { useNotification } from "../../context/notification";
import NudgeService from "../../services/NudgeService";

export function NudgeLogSessions(props) {
  useDocumentTitle(props.title);
  const { t } = useTranslation();
  const history = useHistory();
  const { addNotification } = useNotification();

  const [sessionIds, setSessionIds] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchSessions = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await NudgeService.getNudgeLogSessions();
      setSessionIds(data);
    } catch (error) {
      addNotification(
        t("error.couldNotGetSession") || "Failed to load nudge log sessions",
        "error"
      );
      setSessionIds([]);
    }
    setIsLoading(false);
  }, [addNotification, t]);

  useEffect(() => {
    fetchSessions();
  }, [fetchSessions]);

  const handleViewSession = (sessionId) => {
    history.push(`/nudge-logs/session/${sessionId}`);
  };

  return (
    <DashboardLayout isDisableCampaignSelection={true}>
      <PageContent>
        <Section>
          <SectionTitle>
            {t("nudgeLog.sessionsTitle") || "Nudge Logs - Sessions"}
          </SectionTitle>

          {isLoading ? (
            <div>Loading...</div>
          ) : sessionIds.length === 0 ? (
            <div>{t("nudgeLog.noSessionsFound") || "No sessions with nudge logs found"}</div>
          ) : (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: "2px solid #ccc" }}>
                  <th style={{ textAlign: "left", padding: "12px 8px" }}>Session ID</th>
                  <th style={{ textAlign: "left", padding: "12px 8px" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sessionIds.map((sessionId) => (
                  <tr key={sessionId} style={{ borderBottom: "1px solid #eee" }}>
                    <td style={{ padding: "12px 8px" }}>{sessionId}</td>
                    <td style={{ padding: "12px 8px" }}>
                      <button
                        onClick={() => handleViewSession(sessionId)}
                        style={{
                          padding: "6px 12px",
                          backgroundColor: "#1976d2",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        {t("nudgeLog.viewDetails") || "View Details"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Section>
      </PageContent>
    </DashboardLayout>
  );
}
